import { Trans } from "@lingui/react/macro";
import { observable } from "mobx";
import { useState } from "react";

import { Button } from "../../../components/ui-kit/button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "../../../components/ui-kit/dialog";
import { createPatch } from "../../../utils/patch";
import { AdminConsole } from "../admin-console";
import { MonitoringSettingsItem } from "./monitoring-settings";
import { MonitoringSettingsForm } from "./monitoring-settings-form";

export function EditMonitoringSettingsDialog({
  item,
  admin,
  onClose,
  onSave,
}: {
  item: MonitoringSettingsItem;
  admin: AdminConsole;
  onClose: () => void;
  onSave: (patch: Record<string, unknown>) => Promise<void>;
}) {
  const [fields] = useState(() =>
    observable({
      new_patient_status: item.new_patient_status ?? null,
      auto_schedule: item.auto_schedule,
      requires_measurement_config: item.requires_measurement_config,
      auto_alerts: item.auto_alerts,
      consent_type: item.consent_type ?? null,
      is_monitored: item.is_monitored,
      any_new_data_activate: item.any_new_data_activate,
      ppg_ecg_new_data_activate: item.ppg_ecg_new_data_activate,
      auto_deactivate_after: item.auto_deactivate_after ?? null,
      status_change_email: item.status_change_email,
    }),
  );

  async function save() {
    const body = createPatch(fields, item);
    if (Object.keys(body).length === 0) {
      onClose();
      return;
    }
    await onSave(body);
    onClose();
  }

  return (
    <Dialog open onOpenChange={() => onClose()}>
      <DialogHeader>
        <Trans>Edit monitoring settings</Trans>
      </DialogHeader>
      <DialogBody>
        <MonitoringSettingsForm fields={fields} admin={admin} mode="edit" />
      </DialogBody>
      <DialogFooter>
        <Button onClick={onClose}>
          <Trans>Cancel</Trans>
        </Button>
        <Button variant="primary" onClick={() => save()}>
          <Trans>Save</Trans>
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
